<div class="pm-form-field-toggle-select-container mt-2">
  @for(opt of formField.options; track opt.value) {
  <div
    class="pm-form-field-toggle-chip"
    (click)="onToggleClick(opt.value)"
    [ngClass]="{ selected: isSelected(opt.value) }"
  >
    {{ opt.label }}
  </div>
  }
</div>
